module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAABBCAYAAABfEM01AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATlJREFUeNrE2OsNgzAMBGCK2KSLdHSW6R4tlYogkIftu3MkBD8/QuL4eDzf65Q4Xts1ZwO2hzkbkIU4Ab5jnbMBasQtQPk5qgAVoglQILoANmIIwEQMA1gIE4CBMAPQCBcAiXADUIgQAIEIA6IICCCCgAG8CCjAg4ADrAgKwIKgAUYRVMAIgg7oISSAFkIGqCGkgDuEHFAiUgBHRBrgj0gFZKbyC6J883JmZDORCpkba0EGKddECuRuYcohtd0hhbS2qAzSqxMSyEixokNGKyYVYinbNIj17KBAPAcYHOI9RaGQyFEOg0T7CQgE0dSEIajOKgRBtnduCLrHdEEYja4Zwuq2TRBmyz8MYeeOIYgi/HQhqgTWhChjYBWyiGPnegDs94xAfJmRrFR+gmT+Gtghy5Q7foiPAAMAO/15zl9FRagAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/features_jiantou_left.png
// module id = zHDz
// module chunks = 1